function Directive($timeout) {
  return {
    restrict: 'AC',
    link(_scope, _element) {
      $timeout(() => {
        _element[0].focus();
      }, 0);
    }
  };
}

Directive.$inject = [
  '$timeout'
];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/autofocus/index.js